var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isSwitchFormationStateLoading)?_c('LoadingPageWithQuote'):_vm._e(),(!_vm.isSwitchFormationStateLoading)?_c('ConnectEoloquenceRequest'):_vm._e(),(
			_vm.formationInfos.test_trial &&
			this.$router.currentRoute.name != 'Onboarding' &&
			this.$router.currentRoute.name != 'TestPositionnement' &&
			Object.keys(_vm.formationInfos).length != 0 &&
			this.$router.currentRoute.name != 'ResultsDetail'
		)?_c('TrialFinished'):_vm._e(),_c('CookieConsent'),_c('NavBar',{attrs:{"categoriesDone":_vm.categoriesDone,"formationInfos":_vm.formationInfos,"currentRoute":this.$router.currentRoute}}),_c('v-content',[(_vm.accessToApp)?_c('router-view'):_c('NotOptimized')],1),_c('WebPushNotificationPermission')],1)}
var staticRenderFns = []

export { render, staticRenderFns }